import { createAction, props } from '@ngrx/store';

import { ConnextData } from 'ngx-core-services';

export const updateConnextData = createAction(
  '[System - Connext] Update Connext Data',
  props<{ systemId: string; changes: Partial<ConnextData> }>()
);
